export default "__VITE_ASSET__BGfA4jIg__"